import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ICustodyAccount } from "domains/custodyAccounts/shared/types";

interface IInitialState {
  currentCustodyAccount: ICustodyAccount | null;
  currentFooterCustodyAccount: ICustodyAccount | null;
  custodyAccounts: ICustodyAccount[] | null;
  connectingAssetsWithAccount: boolean | null;
  isEditingCustodyAccount: boolean | null;
}

const initialState: IInitialState = {
  currentCustodyAccount: null,
  currentFooterCustodyAccount: null,
  custodyAccounts: null,
  connectingAssetsWithAccount: null,
  isEditingCustodyAccount: null,
};

const custodyAccountsReducer = createSlice({
  name: "[CustodyAccounts]",
  initialState,
  reducers: {
    setIsEditingCustodyAccount: (state, action: PayloadAction<boolean | null>) => ({
      ...state,
      isEditingCustodyAccount: action.payload,
    }),
    setCustodyAccounts: (state, action: PayloadAction<ICustodyAccount[] | null>) => ({
      ...state,
      custodyAccounts: action.payload,
    }),
    setConnectingAssetsWithAccount: (state, action: PayloadAction<boolean>) => ({
      ...state,
      connectingAssetsWithAccount: action.payload,
    }),
    setCurrentCustodyAccount: (state, action: PayloadAction<ICustodyAccount | null>) => ({
      ...state,
      currentCustodyAccount: action.payload,
    }),

    setCurrentFooterCustodyAccount: (state, action: PayloadAction<ICustodyAccount | null>) => ({
      ...state,
      currentFooterCustodyAccount: action.payload,
    }),

    resetCustodyAccountsReducer: () => initialState,
  },
});

export const {
  setCurrentCustodyAccount,
  setCurrentFooterCustodyAccount,
  setConnectingAssetsWithAccount,
  setIsEditingCustodyAccount,
  setCustodyAccounts,
  resetCustodyAccountsReducer,
} = custodyAccountsReducer.actions;

export default custodyAccountsReducer.reducer;
